import { useCallback, useMemo, useState } from 'react'

import { IForm } from 'core-components/classes/models/IForm'
import { Button } from 'core-components/library/button'
import { Flex } from 'core-components/library/flex'
import { Input } from 'core-components/library/inputs'
import { ITableProps } from 'core-components/library/list/types'
import { BaseCrud } from 'core-components/types'

interface IEditItemContent {
  item: IForm
  columns: ITableProps['columns']
  source: BaseCrud
  onClose: () => void
}

export const EditItemContent = ({ item, columns, source, onClose }: IEditItemContent) => {
  const [saving, setSaving] = useState<boolean>(false)

  const [formData, setFormData] = useState(() => {
    return columns.map((column) => {
      return { key: column.field, value: item[column.field] as string, title: column.title }
    })
  })

  const changeHandler = useCallback((key: string, value: string) => {
    setFormData((prev) => {
      return prev.map((data) => {
        if (data.key === key) {
          return { ...data, value }
        }
        return data
      })
    })
  }, [])

  const saveHandler = useCallback(async () => {
    setSaving(true)
    const newItem = { ...item }
    for (const { key, value } of formData) {
      newItem[key] = value
    }

    // @ts-ignore
    const formId = source.fetcher.spec.formId as string
    if (newItem.EntryId > -1) {
      await source.update(formId, [newItem])
    } else {
      await source.create(formId, [newItem])
    }
    setSaving(false)
    onClose()
  }, [item, source, onClose, formData])

  return (
    <Flex flexDirection={'column'} className={'margin-top-xs'}>
      {formData.map((data) => {
        return (
          <Input
            key={data.key}
            value={data.value}
            label={data.title}
            onChange={(newValue) => {
              changeHandler(data.key, newValue)
            }}
          />
        )
      })}

      <Button icon={'kbase kbase-save'} onClick={saveHandler} loading={saving}>
        {item.EntryId > -1 ? 'Save' : 'Create'}
      </Button>
    </Flex>
  )
}
